module.exports = __webpack_public_path__ + "img/17.03f92b1d.png";